module.exports = __webpack_public_path__ + "img/蒙版组 14.7a2e6242.png";